import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,  Collapse,
} from 'reactstrap';

import {
    LIST,
    NO_DATA_FOUND,
} from "../../../components/i18n/i18n";

import {TT_DELETE, TT_DETAILS, TT_EDIT} from "../../../components/i18n/toolTips";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonTableFilter,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import ProgramFilters from "./_filters";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search} from "../../../redux/actions/atv/programActions";
import {connect} from "react-redux";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

const ProgramList = (props) => {

    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const [collapsed, setCollapsed] = useState(true);

    const dataFilter = {
        fbDataBase : {  id : fbDataBaseId },
        item : {
        }
    }

    useEffect(() => {
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, dataFilter);
            return
        }

        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            data,
            fbDataBaseId : fbDataBaseId,
            remove : props.remove
        });
    };

    const editItem = (data) => {
        props.setViewMode('FORM');
        props.setItem(data);
        props.setForm(true, false, false);
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const editDetails = (data) => {
        props.setViewMode('DETAILS');
        props.setItem(data);
        props.setForm(false, false, false);
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_DETAILS} icon={'fa-clipboard-list'} permission={'edit'} onClick={() => editDetails(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'title',
        text: 'Titulo'
    }, {
        dataField: 'showOrder',
        headerStyle: {width: '50px'},
        text: "Orden de presentación"
    }, {
        dataField: 'status',
        headerStyle: {width: '50px'},
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}  >
                    <ProgramFilters />
                </Collapse>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(ProgramList)
